import { jsx } from 'react/jsx-runtime';
import { Component, createRef } from 'react';
import stringFormat from './stringFormat.js';
import dollarFormat from './dollarFormat.js';

const maskInput = (mask, isDollarFormat) => WrappedComponent => {
  class MaskInputHoc extends Component {
    constructor(props) {
      super(props);
      this.inputRef = createRef();
      const {
        value = '',
        mask: propsMask = '',
        maxlength = 0
      } = props;
      this.maskValue = isDollarFormat ? string => dollarFormat(string, maxlength) : string => stringFormat(string, mask !== null && mask !== void 0 ? mask : propsMask);
      this.state = {
        cursorPosition: 0,
        value: value ? this.maskValue(value) : value,
        difference: 0
      };
      this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate(prevProps) {
      var _a, _b;
      /**
       * if not dollar format and the next mask isn't the same as the current mask
       * update the maskValue with the next mask
       */


      if (!isDollarFormat && this.props.mask !== prevProps.mask) {
        const newMask = (_a = this.props.mask) !== null && _a !== void 0 ? _a : '';

        this.maskValue = string => stringFormat(string, newMask);
      }
      /**
       * if the next value props value has changed from the current
       * set the state of the value with the next value
       */


      if (this.props.value !== prevProps.value) {
        this.setState({
          value: this.maskValue((_b = this.props.value) !== null && _b !== void 0 ? _b : '')
        });
      }

      const {
        cursorPosition,
        difference
      } = this.state;
      const updatedCursorPosition = cursorPosition + difference;

      if (this.inputRef.current && document) {
        this.inputRef.current.setSelectionRange(updatedCursorPosition, updatedCursorPosition);
      }
    }

    handleChange(value, event) {
      var _a, _b;

      const {
        skipDeletions,
        onChange
      } = this.props;
      let cursorPosition = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.selectionStart) !== null && _b !== void 0 ? _b : 0;
      let editValue = value;
      const comparisonMask = this.maskValue(value);
      const stateValue = this.state.value; // due to the nature of live masking we need to specially handle
      // deleting constants (which we will skip over while deleting)

      if (value.length < stateValue.length) {
        let skipped = false;

        for (let i = 0; i < skipDeletions.length && !skipped; i += 1) {
          // check if the characters preceding cursorPosition match this skip of n characters
          const skipChars = skipDeletions[i];

          if ( // if a masked string, and currentPosition matches a skipChar
          !isDollarFormat && comparisonMask.length > cursorPosition && cursorPosition > skipChars.length && skipChars === comparisonMask.slice(cursorPosition + 1 - skipChars.length, cursorPosition + 1) || // or if dollar format, and user had deleted a skipChar
          isDollarFormat && skipChars === stateValue.slice(cursorPosition, cursorPosition + skipChars.length) && skipChars !== editValue.slice(cursorPosition, cursorPosition + skipChars.length)) {
            // delete preceding skipChar
            // or for dollar format, delete the character preceding deleted skipChar
            cursorPosition -= skipChars.length;
            editValue = editValue.slice(0, cursorPosition) + editValue.slice(cursorPosition + 1);
            skipped = true;
          } // When deleting in dollarFormat, adjust cursor to account for varying number of commas


          if (isDollarFormat) {
            cursorPosition -= stateValue.split(',').length - comparisonMask.split(',').length;
          }
        }
      }

      const maskedValue = this.maskValue(editValue);
      const difference = Math.max(0, maskedValue.length - value.length);
      this.setState({
        value: maskedValue,
        cursorPosition,
        difference
      });
      if (onChange) onChange(maskedValue, event);
    }

    render() {
      const {
        value
      } = this.state; // type="tel" required for proper cursor behavior using Chrome 61 on Android 8.0.1
      // TODO: determing if this is still a real concern

      const {
        type = 'tel'
      } = this.props;
      const hocProps = {
        value,
        onChange: this.handleChange
      };
      return jsx(WrappedComponent, Object.assign({
        childRef: c => this.inputRef = c,
        disableSanitize: true
      }, this.props, hocProps, {
        type: type
      }), void 0);
    }

  }

  MaskInputHoc.displayName = 'MaskInputHoc';
  return MaskInputHoc;
};

export { maskInput };
